import React from 'react';
import { Pressable, StyleProp, Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '../../assets/theme';
import { makeStyles } from '../../theme/ThemeContext';

type SectionHeaderProps = {
  title: string;
  subtitle?: string;
  /** Underlined text link on the right (Airbnb "Show all" style). */
  actionLabel?: string;
  onAction?: () => void;
  /** Custom element on the right (buttons, chips…). */
  right?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};

export default function SectionHeader({ title, subtitle, actionLabel, onAction, right, style }: SectionHeaderProps) {
  const styles = useStyles();
  return (
    <View style={[styles.row, style]}>
      <View style={styles.texts}>
        <Text style={styles.title} accessibilityRole="header">{title}</Text>
        {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      </View>
      {right}
      {actionLabel && onAction ? (
        <Pressable onPress={onAction} accessibilityRole="link" hitSlop={8}>
          <Text style={styles.link}>{actionLabel}</Text>
        </Pressable>
      ) : null}
    </View>
  );
}

const useStyles = makeStyles((c) => ({
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 12 },
  texts: { flexShrink: 1 },
  title: { ...TYPOGRAPHY.heading, color: c.textPrimary },
  subtitle: { ...TYPOGRAPHY.caption, color: c.textSecondary, marginTop: 2 },
  link: { ...TYPOGRAPHY.label, color: c.textPrimary, textDecorationLine: 'underline' },
}));
